import { createAsyncThunk } from '@reduxjs/toolkit';
import { DeliverySettingsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  IGetDeliverySettingsDTO,
  IGetDeliverySettingsResponse,
  IUpdateDeliverySettingsResponse,
  IUpdateDeliverySettingsDTO,
} from '@/models/deliverySettings.model';
import { SLICE_NAME } from './models';

export const getDeliverySettings = createAsyncThunk<
  IGetDeliverySettingsResponse,
  IGetDeliverySettingsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getDeliverySettings`,
  async (params) => {
    const response = await DeliverySettingsAPI.getDeliverySettings(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateDeliverySettings = createAsyncThunk<
  IUpdateDeliverySettingsResponse,
  IUpdateDeliverySettingsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateDeliverySettings`,
  async (data) => {
    const response = await DeliverySettingsAPI.updateDeliverySettings(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
